import { Card, CardContent, Grid, Stack, Typography } from '@mui/material';
import CalculateRounded from '@mui/icons-material/CalculateRounded';
import CloudRounded from '@mui/icons-material/CloudRounded';
import LockRounded from '@mui/icons-material/LockRounded';
import QueryStatsRounded from '@mui/icons-material/QueryStatsRounded';
import type { ReactNode } from 'react';
import { PageHeader } from './PageHeader';

function Bloco({
  icone,
  titulo,
  children,
}: {
  icone: ReactNode;
  titulo: string;
  children: ReactNode;
}) {
  return (
    <Card sx={{ height: '100%' }}>
      <CardContent>
        <Stack
          direction="row"
          spacing={1.25}
          sx={{ alignItems: 'center', mb: 1.5, color: 'primary.main' }}
        >
          {icone}
          <Typography variant="h6" component="h2" color="text.primary">
            {titulo}
          </Typography>
        </Stack>
        <Stack
          spacing={1.25}
          sx={{ color: 'text.secondary', '& strong': { color: 'text.primary' } }}
        >
          {children}
        </Stack>
      </CardContent>
    </Card>
  );
}

export function ComoFuncionaPage() {
  return (
    <>
      <PageHeader
        title="Como funciona"
        subtitle="De onde vêm as notas, como elas viram a média e quem vê o quê."
      />
      <Grid container spacing={2}>
        <Grid size={{ xs: 12, md: 6 }}>
          <Bloco icone={<CalculateRounded />} titulo="As notas">
            <Typography>
              <strong>P1</strong> = 0,3 × T1 + 0,5 × nota individual + 0,2 × nota do grupo. A{' '}
              <strong>P2</strong> segue a mesma fórmula com a T2. A <strong>P3</strong> é o projeto
              individual apresentado em aula (em PBDI, 0,3 × exercícios + 0,7 × projeto).
            </Typography>
            <Typography>
              Com frequência de pelo menos 75%: média (P1 + P2) / 2 ≥ 6 aprova. Se não, vale (maior
              entre P1 e P2 + P3) / 2. Quem fez a P3 e chegou a 5,75 tem a nota arredondada para 6.
            </Typography>
          </Bloco>
        </Grid>
        <Grid size={{ xs: 12, md: 6 }}>
          <Bloco icone={<CloudRounded />} titulo="T1 e T2 (AWS Academy)">
            <Typography>
              Saem do relatório do AWS Academy: cada teste de conhecimento ou laboratório dos módulos
              da etapa em que você atingiu pelo menos 70% (o mínimo do AWS Academy) vale 10; abaixo
              disso vale 0; a nota é a média dos itens. Não é preciso entregar nada: basta concluir os
              itens no prazo (T2 até 15/11, 23h59).
            </Typography>
            <Typography>
              Configure o seu <strong>nome completo</strong> em Account → Settings no AWS Academy: é
              por ele que a nota chega até você.
            </Typography>
          </Bloco>
        </Grid>
        <Grid size={{ xs: 12, md: 6 }}>
          <Bloco icone={<QueryStatsRounded />} titulo="As comparações com a turma">
            <Typography>
              Os gráficos mostram a turma só em <strong>agregados</strong>: média, mediana, a faixa
              onde ficou a metade do meio da turma e quantos alunos caíram em cada faixa de nota.
              Nenhuma nota de outro aluno aparece.
            </Typography>
            <Typography>
              "Acima de 70% da turma" quer dizer que 70% dos colegas tiveram nota menor que a sua
              naquela parte.
            </Typography>
          </Bloco>
        </Grid>
        <Grid size={{ xs: 12, md: 6 }}>
          <Bloco icone={<LockRounded />} titulo="Privacidade">
            <Typography>
              Você entra com a conta Google e confirma o RA por um link enviado ao seu e-mail{' '}
              <strong>@aluno.cps.sp.gov.br</strong>. Só depois disso o painel mostra as suas notas,
              e só para essa conta.
            </Typography>
            <Typography>
              Para o professor acompanhar o uso, o painel registra os acessos: quando você entra, as
              páginas que abre e os botões que clica. Nada disso aparece para outros alunos.
            </Typography>
            <Typography>
              O professor guarda também o seu e-mail pessoal (o da conta Google com que você entra, o do AWS Academy e o do formulário
              de entrega) para contato sobre as disciplinas. Celular é opcional: só se você informar, e o professor só vê o número
              enquanto você deixar o contato ligado. Ofertas de conteúdo só chegam se você ligar essa opção. Tudo isso fica em "Seus
              contatos", no fim do painel (ou no menu da sua foto), e muda com um clique.
            </Typography>
            <Typography>
              As notas oficiais são as do SIGA. Achou algo estranho? Fale com o professor em aula ou
              pelo Teams.
            </Typography>
          </Bloco>
        </Grid>
      </Grid>
    </>
  );
}
